import * as React from 'react';
import type { SVGProps } from 'react';

export function EmptyAudienceSvg(props: SVGProps<SVGSVGElement>) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={97} height={49} fill="none" {...props}>
      <path
        fill="#1F1F1F"
        d="M91.617 37.665a5.173 5.173 0 0 0 5.028 5.028 5.173 5.173 0 0 0-5.028 5.028 5.173 5.173 0 0 0-5.028-5.028 5.173 5.173 0 0 0 5.028-5.028Z"
      />
      <rect
        width={21.72}
        height={21.72}
        x={12.234}
        y={0.64}
        stroke="#0F0F0F"
        strokeWidth={0.28}
        rx={1.86}
      />
      <rect
        width={21.72}
        height={21.72}
        x={37.234}
        y={0.64}
        stroke="#0F0F0F"
        strokeWidth={0.28}
        rx={1.86}
      />
      <rect
        width={21.72}
        height={21.72}
        x={62.234}
        y={0.64}
        stroke="#0F0F0F"
        strokeWidth={0.28}
        rx={1.86}
      />
      <rect
        width={9.22}
        height={9.72}
        x={12.234}
        y={25.64}
        stroke="#0F0F0F"
        strokeWidth={0.28}
        rx={1.86}
      />
      <rect
        width={9.22}
        height={9.72}
        x={24.734}
        y={25.64}
        stroke="#0F0F0F"
        strokeWidth={0.28}
        rx={1.86}
      />
      <rect
        width={9.22}
        height={9.72}
        x={37.234}
        y={25.64}
        stroke="#0F0F0F"
        strokeWidth={0.28}
        rx={1.86}
      />
      <rect
        width={9.22}
        height={9.72}
        x={49.734}
        y={25.64}
        stroke="#0F0F0F"
        strokeWidth={0.28}
        rx={1.86}
      />
      <rect
        width={9.22}
        height={9.72}
        x={62.234}
        y={25.64}
        stroke="#0F0F0F"
        strokeWidth={0.28}
        rx={1.86}
      />
      <rect
        width={9.22}
        height={9.72}
        x={74.734}
        y={25.64}
        stroke="#0F0F0F"
        strokeWidth={0.28}
        rx={1.86}
      />
      <rect
        width={9.22}
        height={9.72}
        x={12.234}
        y={38.64}
        stroke="#0F0F0F"
        strokeWidth={0.28}
        rx={1.86}
      />
      <rect
        width={9.22}
        height={9.72}
        x={24.734}
        y={38.64}
        stroke="#0F0F0F"
        strokeWidth={0.28}
        rx={1.86}
      />
      <rect
        width={9.22}
        height={9.72}
        x={37.234}
        y={38.64}
        stroke="#0F0F0F"
        strokeWidth={0.28}
        rx={1.86}
      />
      <rect
        width={9.22}
        height={9.72}
        x={49.734}
        y={38.64}
        stroke="#0F0F0F"
        strokeWidth={0.28}
        rx={1.86}
      />
      <rect
        width={9.22}
        height={9.72}
        x={62.234}
        y={38.64}
        stroke="#0F0F0F"
        strokeWidth={0.28}
        rx={1.86}
      />
      <rect
        width={9.22}
        height={9.72}
        x={74.734}
        y={38.64}
        stroke="#0F0F0F"
        strokeWidth={0.28}
        rx={1.86}
      />
      <path
        fill="#1F1F1F"
        d="M7.865.775a7.716 7.716 0 0 0 7.5 7.5 7.716 7.716 0 0 0-7.5 7.5 7.716 7.716 0 0 0-7.5-7.5 7.716 7.716 0 0 0 7.5-7.5Z"
      />
    </svg>
  );
}
